<template>
    <div @mouseover="isHovered = true" @mouseleave="isHovered = false">
        <router-link :to="routeTo" :class="[isActive ? 'active' : '', img ? '' : 'no-img']">
            <b-img v-if="img" :src="(isActive || isHovered) ? hoverImg : img" />
            <span class="links_name" :class="(isActive || isHovered) ? 'o-1' : ''">
                {{ name }}
            </span>
        </router-link>
    </div>
</template>
<script>
export default {
    name: "SidebarItem",
    props: ["routeTo", "activeRoute", 'img', 'hoverImg', "name", "activeFor"],
    data() {
        return {
            isHovered: false
        }
    },
    computed: {
        isActive() {
            const paths = [this.routeTo, ...(this.activeFor || [])];
            return paths.some(
                (p) => this.activeRoute === p || this.activeRoute.startsWith(p + '/')
            );
        }
    }
}
</script>
<style>
.sidebar li a.no-img {
    width: 185px;
    margin: 5px 35px 0px;
    display: flex;
    border-left: none !important;
    border-radius: 5px;
}

.sidebar li a.no-img .links_name {
    margin-left: 14px;
}

.sidebar li a.no-img.active {
    background: rgba(255, 255, 255, 0.1) !important;
}
</style>